import { Entity, MicroMClient } from "@mcurros2/microm";
import { VisitasATiendasFiltersDef } from "./VisitasATiendasFiltersDef";


export class VisitasATiendasFilters extends Entity<VisitasATiendasFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new VisitasATiendasFiltersDef(), parentKeys);
        this.Form = import('./VisitasATiendasFiltersForm').then((module) => module.VisitasATiendasFiltersForm);
        this.Title = "Filtros de Visitas";
    }
}